module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/meal-2a1519545a7b3b38c75494e74d40e1f9.webp";